<div class="row">
    <ng-container *ngFor="let image of images">
        <div class="col-md-4 col-lg-3 pb-3">
            <cv-invision-photo-card 
                [info]="image"
                [address]="order.description"
                [isSelected]="photosSelected.indexOf(image.id) > -1"
                [isEditing]="isEditing"
                (selectedPhoto)="selectedPhoto($event)"
                (setMainPhoto)="setMainPhoto($event)"
                (openGallery)="openGallery($event)">
            </cv-invision-photo-card>
        </div>
    </ng-container>
</div>
